import { render, staticRenderFns } from "./videoClassification.vue?vue&type=template&id=a4be7104"
import script from "./videoClassification.vue?vue&type=script&lang=js"
export * from "./videoClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4be7104')) {
      api.createRecord('a4be7104', component.options)
    } else {
      api.reload('a4be7104', component.options)
    }
    module.hot.accept("./videoClassification.vue?vue&type=template&id=a4be7104", function () {
      api.rerender('a4be7104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/video/videoClassification.vue"
export default component.exports